export default __webpack_public_path__ + "static/media/pinterest.becb891d.svg";